import store from "../store";
import { CWS } from '@cmbi/lib';

let reportCws;
const reportCWS = res => {
    const userId = store.state.home.user.user_id || "";
    if (!reportCws || (!reportCws?.userId && userId)) {
        reportCws =  new CWS('h5_knowledge', userId, process.env.cwsUrl, process.env.VERSION);
    }
    reportCws.report(res);
};

export default reportCWS;